import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { isBrowser } from 'app/infrastructure/universal';

let hasCrashedAlready = false;
/**
 *
 * Application crash is when we are in a "non-recoverable application state"
 *
 * A crash would only be expected when:
 *
 *  - Application cannot start and crashes before react mounts the root component
 *
 * But may also happen when
 *
 *  - A reducer throws an unhandled exception and puts redux into zombie mode due to missing state. Note
 *    that all action creators should be wrapped in a tryDispatch() wrapper so this should never happen.
 *  - 3rd party code causes a TypeError that stops execution and bubbles up the stack possibly breaks e.g React.
 *
 * When a crash happens, it's ok to replace the whole application with an error message as we are not able to
 * recover anyway. User shuld in those cases be offered help, e.g a reload link.
 *
 */
export const crashNotification = (message: string, details?: string) => {

  if (!isBrowser || hasCrashedAlready) {
    return;
  }

  hasCrashedAlready = true;

  const renderView = () => {
    const container = document.getElementById('react-app');
    const root = createRoot(container);

    root.render(
      <div className="alert alert-warning" >
        <div className="card">
          <div className="card-header">
            {message && message.toString()}
          </div>
          <div className="card-block">
            {details && <div className="card"><ul className="list-group list-group-flush">{details && details.toString()}</ul></div>}
          </div>
        </div>
      </div>
    );
  };

  // The error might have fired in a script before window was loaded
  if (document.readyState === 'complete') {
    renderView();
  } else {
    window.onload = renderView;
  }

};
